<div class="modal-header">
    <h5 class="modal-title" id="profileModalTitle">Edit Liaison Info</h5>
    <button type="button" (click)="dismiss()" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
</div>
<div class="modal-body">
    <form [formGroup]="manageLiaisonInfoForm">
        <div class="row gx-3">
            <div class="col-md-6 mb-3">
                <label for="liaisonFirstName" class="form-label">Liaison First Name<sup class="text-danger">*</sup></label>
                <input type="text" class="form-control" id="liaisonFirstName" placeholder="First Name" formControlName="liaisonFirstName" autofocus>
                <div *ngIf="liaisonFirstNameCtrl.invalid && (liaisonFirstNameCtrl.dirty || liaisonFirstNameCtrl.touched)">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
            <div class="col-md-6 mb-3">
                <label for="liaisonLastName" class="form-label">Liaison Last Name<sup class="text-danger">*</sup></label>
                <input type="text" class="form-control" id="liaisonLastName" placeholder="Last Name" formControlName="liaisonLastName" autofocus>
                <div *ngIf="liaisonLastNameCtrl.invalid && (liaisonLastNameCtrl.dirty || liaisonLastNameCtrl.touched)">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
        </div>
        <div class="row gx-3">
            <div class="col-md-12 mb-3">
                <label for="liaisonEmail" class="form-label">Liaison Email Address<sup class="text-danger">*</sup></label>
                <input type="text" class="form-control" id="liaisonEmail" placeholder="Email Address" formControlName="liaisonEmail" autofocus>
                <div *ngIf="liaisonEmailCtrl.invalid && (liaisonEmailCtrl.dirty || liaisonEmailCtrl.touched)">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
        </div>
        <div class="row gx-3">
            <div class="col-md-12 mb-3">
                <label for="liaisonPhone" class="form-label">Liaison Phone<sup class="text-danger">*</sup></label>
                <input type="text" class="form-control" id="liaisonPhone" placeholder="(123) 123-1234" formControlName="liaisonPhone" autofocus mask="(000) 000-0000">
                <div *ngIf="liaisonPhoneCtrl.invalid && (liaisonPhoneCtrl.dirty || liaisonPhoneCtrl.touched)">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
        </div>
        <div class="row gx-3">
            <div class="col-md-12 mb-3">
                <label for="liaisonTitle" class="form-label">Liaison Job Title<sup class="text-danger">*</sup></label>
                <input type="text" class="form-control" id="liaisonTitle" placeholder="Job Title" formControlName="liaisonTitle" autofocus>
                <div *ngIf="liaisonTitleCtrl.invalid && (liaisonTitleCtrl.dirty || liaisonTitleCtrl.touched)">
                    <i class="fas fa-exclamation-circle"></i> This field is required.
                </div>
            </div>
        </div>
    </form>
</div>
<div class="modal-footer">
    <button type="button" (click)="saveLiaisonInfo()" [disabled]="isBusy" class="btn btn-sb border-lb text-strong text-uppercase m-100">Save</button>
    <button type="button" (click)="dismiss()" class="btn btn-cancel text-strong text-uppercase m-100" data-bs-dismiss="modal">Cancel</button>
</div>
